import React, { useEffect } from 'react';

import { getPlatform } from '../../utils/platformHelpers';
import {
  SLEEPIO_APP_STORE_URL,
  SLEEPIO_GOOGLE_PLAY_URL,
  SPARK_APP_STORE_URL,
  SPARK_GOOGLE_PLAY_URL,
} from '../../utils/constants';

import { Platform, isSpark as isSparkHelper } from '@/utils/productHelpers';

const AppStoreRedirector = (): React.ReactElement => {
  useEffect(() => {
    const platform = getPlatform();
    const qsProduct = new URLSearchParams(window.location?.search ?? '').get('product') ?? undefined;
    const pathProduct = (window.location?.pathname ?? '').match(
      /(spark(?:[-_.\s]direct|[-_.\s]wellness|[-_.\s]2\.0)?)/i,
    )?.[1];
    const isSpark = isSparkHelper(qsProduct ?? pathProduct);

    if (platform === Platform.Android) {
      window.location.href = isSpark ? SPARK_GOOGLE_PLAY_URL : SLEEPIO_GOOGLE_PLAY_URL;
    }
    if (platform === Platform.iOS) {
      window.location.href = isSpark ? SPARK_APP_STORE_URL : SLEEPIO_APP_STORE_URL;
    }
  }, []);

  return <h1>Redirecting...</h1>;
};

export default AppStoreRedirector;
